/* global downloadAttachmentUrl */

import React from 'react';

import moment from 'moment';

import ApproversTable from '../user/ApproversTable';

import PurchaseOrderApprovedLinesTable from './PurchaseOrderApprovedLinesTable';

import { downloadSource } from 'Helpers/urlService';

import Button from 'CommonComponents/Button';
import FormHorizontalSeparator from 'CommonComponents/FormHorizontalSeparator';
import FormSectionHeading from 'CommonComponents/FormSectionHeading';
import FormTextRow from 'CommonComponents/FormTextRow';
import ModalHeader from 'CommonComponents/ModalHeader';

const EMPTY = '—';

const formatDate = (value) => {
    const date = moment(value);

    return value && date.isValid() ? date.format('DD/MM/YYYY') : EMPTY;
};

export default function PurchaseOrdersViewModal(props) {
    const getDownloadUrl = (poId, attachmentId) => {
        return downloadAttachmentUrl.replace('ORDER_ID', poId).replace('ATTACHMENT_ID', attachmentId);
    };

    const downloadAttachment = (e, budgetId, attachmentId, path) => {
        e.preventDefault();
        downloadSource(path, getDownloadUrl(budgetId, attachmentId));
    };

    const close = () => {
        props.closeHandler();
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Expenditure Approval Details')} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {Object.keys(props.po).length > 0 && (
                            <div className="modal__form-container">
                                <FormTextRow label={$t('EA code') + ':'} text={props.po.code || EMPTY}></FormTextRow>

                                <FormTextRow label={$t('Title') + ':'} text={props.po.purchase_requisition?.title || EMPTY}></FormTextRow>

                                <FormTextRow label={$t('Requestor Name') + ':'} text={props.po.requested_by?.email || EMPTY}></FormTextRow>

                                <FormTextRow
                                    label={$t('Budget Owner Name') + ':'}
                                    text={props.po.owner ? `${props.po.owner?.first_name} ${props.po.owner?.last_name}` : EMPTY}
                                ></FormTextRow>

                                <FormTextRow label={$t('Submission Date') + ':'} text={formatDate(props.po.submission_date)}></FormTextRow>

                                <FormTextRow
                                    label={$t('Procurement method') + ':'}
                                    text={props.po.procurement_policy ? props.po.procurement_policy.method : EMPTY}
                                ></FormTextRow>

                                <FormTextRow label={$t('Recommended Supplier') + ':'} text={props.po.supplier?.name || EMPTY}></FormTextRow>

                                <FormTextRow
                                    label={$t('Contract Reference') + ':'}
                                    text={props.po.supplier_contract ? props.po.supplier_contract.contract_reference : $t('New Contract')}
                                ></FormTextRow>

                                <FormTextRow label={$t('Contract Start Date') + ':'} text={formatDate(props.po.contract_started_at)}></FormTextRow>

                                <FormTextRow label={$t('Contract Ended Date') + ':'} text={formatDate(props.po.contract_ended_at)}></FormTextRow>

                                <FormTextRow label={$t('Expenditure description') + ':'} text={props.po.description || EMPTY} isPreTag={true}></FormTextRow>

                                <FormTextRow
                                    label={$t('Overview of Procurement Process') + ':'}
                                    text={props.po.overview || EMPTY}
                                    isPreTag={true}
                                ></FormTextRow>

                                <FormTextRow label={$t('Responses / quotes') + ':'} text={props.po.responses || EMPTY} isPreTag={true}></FormTextRow>

                                <FormTextRow label={$t('Conflicts of Interest') + ':'} text={props.po.conflicts || EMPTY} isPreTag={true}></FormTextRow>

                                <FormTextRow label={$t('Risks') + ':'} text={props.po.risks || EMPTY} isPreTag={true}></FormTextRow>

                                <FormTextRow label={$t('Other Information') + ':'} text={props.po.other || EMPTY} isPreTag={true}></FormTextRow>

                                <FormHorizontalSeparator></FormHorizontalSeparator>

                                <div className="tw-grid tw-grid-cols-1">
                                    <FormSectionHeading heading={$t('Budget lines')}></FormSectionHeading>
                                </div>
                                <div className="tw-grid tw-grid-cols-1">
                                    <PurchaseOrderApprovedLinesTable po={props.po} />
                                </div>

                                <FormSectionHeading heading={$t('Attachments')}></FormSectionHeading>
                                {props.po.attachments && props.po.attachments.length > 0 && (
                                    <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                                        {props.po.attachments.map((attachment) => (
                                            <div className="tw-flex tw-flex-row tw-justify-between tw-items-center" key={attachment.id}>
                                                <a href="#" onClick={(e) => downloadAttachment(e, props.po.id, attachment.id, attachment.path)}>
                                                    {attachment.path}
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {props.po.attachments && props.po.attachments.length === 0 && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <p className="tw-text-base tw-text-charcoal tw-font-semibold">{$t('No attachments')}</p>
                                    </div>
                                )}

                                <FormHorizontalSeparator></FormHorizontalSeparator>

                                <div className="tw-grid tw-grid-cols-1">
                                    <FormSectionHeading heading={$t('Approval History')}></FormSectionHeading>
                                </div>
                                <div className="table__card">
                                    <ApproversTable
                                        approvers={props.po.approval_history || props.po.approvers || []}
                                        status={props.po.status}
                                        displayApprovalStatuses={props.displayApprovalStatuses}
                                    />
                                </div>

                                {!!props.po.canceled_at && !!props.po.canceled_by && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <table className="my-3 table  table-bordered no-footer">
                                            <thead className="text-dark-blue">
                                                <tr>
                                                    <th>{$t('Canceled By')}</th>
                                                    <th>{$t('Date')}</th>
                                                    <th>{$t('Status')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        {props.po.canceled_by.first_name} {props.po.canceled_by.last_name}
                                                    </td>
                                                    <td>{formatDate(props.po.canceled_at)}</td>
                                                    <td>{props.po.status_label}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {!!props.openRecordUrl && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <a
                                            href={props.openRecordUrl}
                                            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-blue hover:tw-underline"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {$t('Open EA in InBudget')}
                                        </a>
                                    </div>
                                )}

                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={close}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
